import { useTranslation } from 'react-i18next';
import React, { useEffect, useState, useContext } from "react";
import { Table } from "antd";
import { YhBox } from "@/erp_subpackage/components/YhBox";
import { YhPageHeader } from "@/erp_subpackage/components/YhPageHeader";
import { usecontractDetailsModel } from './detailsModel'
import { formatNum } from '@/erp_subpackage/utils/util';
import { getPcodeDict } from "@/utils/dataStorage"
import { useDictModel } from "@/erp_subpackage/pages/base/dict/dictModel"
import { DictCodeEnmu } from "@/erp_subpackage/utils/DictCodeEnum"


export const WorkOrderInfoTable = ({ }) => {
    const {t} = useTranslation()
    const { loading, workOrderData, pgCfgwork, editFormVal, lookFormVal, serachworke, setSerachworke, descTotalwork, openWorkerOrder
    } = usecontractDetailsModel()
    const { getSelectedDictOne } = useDictModel()

    const updateSearchParamt = (updateParam) => {
        setSerachworke({ ...serachworke, ...updateParam })
    }

    const resetSearchParamt = () => {
        setSerachworke({});
        openWorkerOrder({ customerId: editFormVal.customerId ?? lookFormVal.customerId ?? "", });
    }
    const column2 = [
        {
            title:  t(`contractManagement.view.WorkOrderTable.序号`),
            width: 40,
            render: (t, r, i) => `${i + 1}`,
            fixed: 'left'
        },
        {
            title:  t(`contractManagement.view.WorkOrderTable.单据编号`),
            width: 180,
            dataIndex: 'orderCode',
            fixed: "left",
        },
        {
            title:  t(`contractManagement.view.WorkOrderTable.支付状态`),
            width: 120,
            dataIndex: 'payStatus',
            fixed: "left",
        }, {
            title:  t(`contractManagement.view.WorkOrderTable.工单类型`),
            width: 120,
            dataIndex: 'orderType',
            fixed: "left",
        }, {
            title:  t(`contractManagement.view.WorkOrderTable.三包信息`),
            width: 280,
            dataIndex: 'threeGuaranteesInfo',

        }, {
            title:  t(`contractManagement.view.WorkOrderTable.工时费`),
            width: 100,
            dataIndex: 'hourlyWage',
            render: (text) => { return (text ?? 0).toFixed(2) }

        }, {
            title:  t(`contractManagement.view.WorkOrderTable.材料费`),
            width: 100,
            dataIndex: 'materialAmount',
            render: (text) => { return (text ?? 0).toFixed(2) }

        },
        {
            title:  t(`contractManagement.view.WorkOrderTable.外出费`),
            width: 100,
            dataIndex: 'travelExpenses',
            render: (text) => { return (text ?? 0).toFixed(2) }

        },
        {
            title:  t(`contractManagement.view.WorkOrderTable.餐补费`),
            width: 100,
            dataIndex: 'mealSupplement',
            render: (text) => { return (text ?? 0).toFixed(2) }

        },
        {
            title:  t(`contractManagement.view.WorkOrderTable.其他费用`),
            width: 100,
            dataIndex: 'otherItemActualAmount',
            render: (text) => { return (text ?? 0).toFixed(2) }

        },
        {
            title:  t(`contractManagement.view.WorkOrderTable.三包工时费汇总`),
            width: 120,
            dataIndex: 'threeGuaranteesTotalHourlyWage',
            render: (text) => { return (text ?? 0).toFixed(2) }

        }, {
            title:  t(`contractManagement.view.WorkOrderTable.费用金额`),
            width: 100,
            dataIndex: 'totalAmount',
            render: (text) => { return (text ?? 0).toFixed(2) }

        }, {
            title:  t(`contractManagement.view.WorkOrderTable.预付款`),
            width: 100,
            dataIndex: 'prepayments',
            render: (text) => { return (text ?? 0).toFixed(2) }

        }, {
            title:  t(`contractManagement.view.WorkOrderTable.已收金额`),
            width: 100,
            dataIndex: 'paidAmount',
            render: (text) => { return (text ?? 0).toFixed(2) }
        }, {
            title:  t(`contractManagement.view.WorkOrderTable.应收金额`),
            width: 100,
            dataIndex: 'payableAmount',
            render: (text) => { return (text ?? 0).toFixed(2) }

        }, {
            title:  t(`contractManagement.view.WorkOrderTable.车辆牌照`),
            width: 100,
            dataIndex: 'vehicleCode',

        }, {
            title:  t(`contractManagement.view.WorkOrderTable.VIN码`),
            width: 180,
            dataIndex: 'vehicleVin',

        }, {
            title:  t(`contractManagement.view.WorkOrderTable.结算方`),
            width: 180,
            dataIndex: 'settlementParty',

        },
        // {
        //     title: '出账日期',
        //     width: 180,
        //     dataIndex: 'billDate',

        // },
        {
            title:  t(`contractManagement.view.WorkOrderTable.开单日期`),
            width: 180,
            dataIndex: 'createTime',

        }, {
            title:  t(`contractManagement.view.WorkOrderTable.结算日期`),
            width: 180,
            dataIndex: 'settlementTime',

        }, {
            title:  t(`contractManagement.view.WorkOrderTable.核销日期`),
            width: 180,
            dataIndex: 'writeOffTime',

        },
    ]

    const searchFields1 = [
        {
            type: "Select",
            placeholder:  t(`contractManagement.view.WorkOrderTable.支付状态`),
            fieldName: "payStatus",
            options: [{ label:  t(`contractManagement.view.WorkOrderTable.已记账`), value: 'pay-status.bill', key: "pay-status.bill" }, { label:  t(`contractManagement.view.WorkOrderTable.已核销`), value: 'pay-status.write-off', key: "pay-status.write-off" }]

        },
        {
            type: "Input",
            placeholder:  t(`contractManagement.view.WorkOrderTable.车辆牌照`),
            fieldName: "vehicleCode"
        },
        {
            type: "Input",
            placeholder:  t(`contractManagement.view.WorkOrderTable.三包信息`),
            fieldName: "threeGuaranteesInfo"
        }, {
            type: "Select",
            placeholder:  t(`contractManagement.view.WorkOrderTable.工单类型`),
            fieldName: "orderType",
            options: getPcodeDict('014').children.map(item => {
                return ({ label: item.title, value: item.dictCode, key: item.id })
            }),
        }, {
            type: "Select",
            placeholder:  t(`contractManagement.view.WorkOrderTable.结算方`),
            fieldName: "settlementParty",
            options: getSelectedDictOne(DictCodeEnmu.SETTLE_PARTY)
        },

        {
            type: "Input",
            placeholder:  t(`contractManagement.view.WorkOrderTable.单据编号`),
            fieldName: "orderCode"
        },

    ]

    const searchMoreFields = [

        {
            type: "Datepicker",
            placeholder:  t(`contractManagement.view.WorkOrderTable.结算日期`),
            fieldName: "settlementTime"
        },
        {
            type: "Datepicker",
            placeholder:  t(`contractManagement.view.WorkOrderTable.开单日期`),
            fieldName: "createTime"
        }, {
            type: "Datepicker",
            placeholder:  t(`contractManagement.view.WorkOrderTable.核销日期`),
            fieldName: "writeOffTime"
        },

    ]


    const desc1 = [
        {
            label:  t(`contractManagement.view.WorkOrderTable.工时费`),
            value: "￥" + (descTotalwork.hourlyWage ?? 0).toFixed(2),
            color: "red"
        },
        {
            label:  t(`contractManagement.view.WorkOrderTable.材料费`),
            value: "￥" + (descTotalwork.materialAmount ?? 0).toFixed(2),
            color: "red"
        },
        {
            label:  t(`contractManagement.view.WorkOrderTable.外出费`),
            value: "￥" + (descTotalwork.travelExpenses ?? 0).toFixed(2),
            color: "red"
        },
        {
            label:  t(`contractManagement.view.WorkOrderTable.餐补费`),
            value: "￥" + (descTotalwork.mealSupplement ?? 0).toFixed(2),
            color: "red"
        },
        {
            label:  t(`contractManagement.view.WorkOrderTable.三包工时汇总`),
            value: "￥" + (descTotalwork.threeGuaranteesTotalHourlyWage ?? 0).toFixed(2),
            color: "red"
        },
        {
            label:  t(`contractManagement.view.WorkOrderTable.费用金额`),
            value: "￥" + (descTotalwork.totalAmount ?? 0).toFixed(2),
            color: "red"
        },
        {
            label:  t(`contractManagement.view.WorkOrderTable.预付款`),
            value: "￥" + (descTotalwork.prepayments ?? 0).toFixed(2),
            color: "red"
        }, {
            label:  t(`contractManagement.view.WorkOrderTable.已收金额`),
            value: "￥" + (descTotalwork.paidAmount ?? 0).toFixed(2),
            color: "red"
        }, {
            label:  t(`contractManagement.view.WorkOrderTable.应收金额`),

            value: "￥" + (descTotalwork.payableAmount ?? 0).toFixed(2),
            color: "red"
        },

    ]

    return (
        <>

            <YhBox descriptions={desc1}>
                <YhPageHeader
                    size="small"
                    justify="start"
                    triggerSearch
                    searchValues={serachworke}
                    searchFields={searchFields1}
                    searchMoreFields={searchMoreFields}
                    onChange={updateSearchParamt}
                    handleSearch={() => { openWorkerOrder({ ...serachworke }) }}
                    handleReset={resetSearchParamt}
                />
                <div>
                    <Table
                        columns={column2}
                        loading={loading}
                        dataSource={workOrderData}
                        scroll={{ y: 600 }}
                        pagination={{
                            ...pgCfgwork,
                            position: ["bottomCenter"],
                            showTotal: () => `${ t(`contractManagement.view.WorkOrderTable.共`)}${pgCfgwork.total}${ t(`contractManagement.view.WorkOrderTable.条`)}`,
                            onChange: (pageNum, pageSize) => {
                                openWorkerOrder(({ pageSize, pageNum }));
                            }
                        }}
                    />
                </div>
            </YhBox>

        </>

    )

}